// 移植自 crm/src/components/Spin.jsx。共用 loading spinner，幾何取自 Figma「Size」展示卡（node 9206:17050），
// 推導與為何不復現 Figma 旋轉層的說明見舊版檔頭。
// 顏色 fill=currentColor，預設 text-brand-primary；放進綠底按鈕要傳 className="text-white"，否則看不見。

// a/b ＝ 四點圓心的兩個座標值（左上 (a,a)、右下 (b,b)）；三種 size 的點徑比例不同，不能共用 viewBox 縮放
const GEOM = {
  sm: { box: 14, r: 2.25, a: 3, b: 11 },
  md: { box: 20, r: 3.375, a: 4.505, b: 15.495 },
  lg: { box: 32, r: 5.625, a: 7.5, b: 24.5 },
}

// 完整字面常數：class 內插值算出來的話 Tailwind 掃不到
const BOX = { sm: 'size-3.5', md: 'size-5', lg: 'size-8' }

export function Spin({ size = 'md', className = '' }) {
  const g = GEOM[size]
  return (
    <svg
      role="status"
      viewBox={`0 0 ${g.box} ${g.box}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`animate-spin text-brand-primary ${BOX[size]} ${className}`}
    >
      {/* 四點順時針排列，opacity 依序遞減（Figma node 9206:17059~17062） */}
      <circle cx={g.a} cy={g.a} r={g.r} fill="currentColor" opacity="0.89" />
      <circle cx={g.b} cy={g.a} r={g.r} fill="currentColor" opacity="0.83" />
      <circle cx={g.b} cy={g.b} r={g.r} fill="currentColor" opacity="0.55" />
      <circle cx={g.a} cy={g.b} r={g.r} fill="currentColor" opacity="0.33" />
    </svg>
  )
}
